module.exports = __webpack_public_path__ + "static/media/web-dev.85e528b1.jpg";